// extracted by mini-css-extract-plugin
export var breadCrumbIcon = "V_c1";
export var breadcrumbElement = "V_cX";
export var heroMargins = "V_c0";
export var listBreadcrumb = "V_cZ";
export var listBreadcrumbModeDark = "V_cY";
export var listBreadcrumbModeLight = "V_cW";